require('../../modules/es6.math.log10');
module.exports = require('../../modules/_core').Math.log10;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/math/log10.js
// module id = 935
// module chunks = 9